// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropDownWithButtonComponent {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  margin-left: 5%;
}
.dropDownWithButtonComponent .inputLabel {
  position: relative;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #353d47;
  padding-bottom: 4px;
  margin-top: 32px;
}
.dropDownWithButtonComponent .dropDownWrapper {
  position: relative;
  margin-top: 4px;
  margin-left: 0px;
  display: flex;
  flex-direction: row;
}
.dropDownWithButtonComponent .dropDownWrapper .inputWrapper {
  padding: 16px;
  position: relative;
  height: 50px;
  padding-top: 7px;
  font-weight: 400;
  padding-left: 16px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  width: 75%;
  display: inline-block;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  display: flex;
  flex-direction: row;
}
.dropDownWithButtonComponent .dropDownWrapper .inputWrapper .selectionImageWrapper {
  position: relative;
  top: 6px;
}
.dropDownWithButtonComponent .dropDownWrapper .inputWrapper .selectionImageWrapper img {
  width: 20px;
}
.dropDownWithButtonComponent .dropDownWrapper button {
  display: inline-block;
  width: 25%;
  height: 50px;
  position: relative;
  border: 1px solid #e1e1e1;
  border-left: none;
  background-color: white;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #075453;
}
.dropDownWithButtonComponent .dropDownWrapper .selectField {
  position: relative;
  top: 5px;
  opacity: 100 !important;
  height: 20px;
  width: 98% !important;
  border: none;
  font-size: 16px;
  font-family: "Inter";
  color: #353d47;
  background-color: white;
}
.dropDownWithButtonComponent .dropDownWrapper .selectField option {
  padding: 10px;
  font-size: 16px;
  background-color: #f2f2f2;
  color: #333;
  border: none;
  position: relative;
}
.dropDownWithButtonComponent .selectionDetails {
  margin-top: 17px;
}
.dropDownWithButtonComponent .selectionDetails .row {
  display: flex;
  margin-bottom: 11px;
}
.dropDownWithButtonComponent .selectionDetails .row .rowLabel {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #999999;
}
.dropDownWithButtonComponent .selectionDetails .row .rowValue {
  margin-left: 24px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  color: #505054;
}
.dropDownWithButtonComponent .selectionDetails .row .rowValue .indicator {
  color: #4b3563;
  padding: 2px 6px;
  gap: 10px;
  background: #ece1f6;
  border-radius: 4px;
  margin-right: 6px;
}
.dropDownWithButtonComponent .buttonRow {
  margin-top: 40px;
}
.dropDownWithButtonComponent .buttonRow button {
  align-items: center;
  padding: 12px 16px;
  gap: 10px;
  width: 268px;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  margin-right: 10px;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
}
.dropDownWithButtonComponent .buttonRow .success {
  background: #075453;
  color: white;
}
.dropDownWithButtonComponent .buttonRow .disabled {
  background: #c1c1c1;
  color: #e1e1e1;
}`, "",{"version":3,"sources":["webpack://./src/screens/batch-application-of-labor-templates/dropdown-with-button/DropDownWithButton.scss"],"names":[],"mappings":"AAAA;EACI,iCAAA;EACA,kBAAA;EACA,eAAA;AACJ;AACI;EACI,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AACR;AACI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AACR;AAAQ;EACI,aAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;AAEZ;AADY;EACI,kBAAA;EACA,QAAA;AAGhB;AAFgB;EACI,WAAA;AAIpB;AAAQ;EACI,qBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,uBAAA;EACA,4BAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAEZ;AAAQ;EACI,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,uBAAA;AAEZ;AADY;EACI,aAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAGhB;AAEI;EACI,gBAAA;AAAR;AACQ;EACI,aAAA;EACA,mBAAA;AACZ;AAAY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAEhB;AAAY;EACI,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;AAEhB;AADgB;EACI,cAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAGpB;AAGI;EACI,gBAAA;AADR;AAEQ;EACI,mBAAA;EACA,kBAAA;EACA,SAAA;EAEA,YAAA;EACA,YAAA;EACA,mBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAFZ;AAKQ;EACI,mBAAA;EACA,YAAA;AAHZ;AAMQ;EACI,mBAAA;EACA,cAAA;AAJZ","sourcesContent":[".dropDownWithButtonComponent {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    margin-left: 5%;\n\n    .inputLabel {\n        position: relative;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #353d47;\n        padding-bottom: 4px;\n        margin-top: 32px;\n    }\n    .dropDownWrapper {\n        position: relative;\n        margin-top: 4px;\n        margin-left: 0px;\n        display: flex;\n        flex-direction: row;\n        .inputWrapper {\n            padding: 16px;\n            position: relative;\n            height: 50px;\n            padding-top: 7px;\n            font-weight: 400;\n            padding-left: 16px;\n            background: #ffffff;\n            border: 1px solid #e9e9e9;\n            border-radius: 8px;\n            width: 75%;\n            display: inline-block;\n            border-top-right-radius: 0;\n            border-bottom-right-radius: 0;\n            display: flex;\n            flex-direction: row;\n            .selectionImageWrapper {\n                position: relative;\n                top: 6px;\n                img {\n                    width: 20px;\n                }\n            }\n        }\n        button {\n            display: inline-block;\n            width: 25%;\n            height: 50px;\n            position: relative;\n            border: 1px solid #e1e1e1;\n            border-left: none;\n            background-color: white;\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 22px;\n            text-align: center;\n            color: #075453;\n        }\n        .selectField {\n            position: relative;\n            top: 5px;\n            opacity: 100 !important;\n            height: 20px;\n            width: 98% !important;\n            border: none;\n            font-size: 16px;\n            font-family: 'Inter';\n            color: #353d47;\n            background-color: white;\n            option {\n                padding: 10px;\n                font-size: 16px;\n                background-color: #f2f2f2;\n                color: #333;\n                border: none;\n                position: relative;\n            }\n        }\n    }\n\n    .selectionDetails {\n        margin-top: 17px;\n        .row {\n            display: flex;\n            margin-bottom: 11px;\n            .rowLabel {\n                font-weight: 500;\n                font-size: 14px;\n                line-height: 20px;\n                color: #999999;\n            }\n            .rowValue {\n                margin-left: 24px;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                display: flex;\n                color: #505054;\n                .indicator {\n                    color: #4b3563;\n                    padding: 2px 6px;\n                    gap: 10px;\n                    background: #ece1f6;\n                    border-radius: 4px;\n                    margin-right: 6px;\n                }\n            }\n        }\n    }\n\n    .buttonRow {\n        margin-top: 40px;\n        button {\n            align-items: center;\n            padding: 12px 16px;\n            gap: 10px;\n\n            width: 268px;\n            height: 56px;\n            background: #ffffff;\n\n            border: 1px solid #e1e1e1;\n            border-radius: 8px;\n            margin-right: 10px;\n            font-weight: 700;\n            font-size: 16px;\n            line-height: 22px;\n        }\n\n        .success {\n            background: #075453;\n            color: white;\n        }\n\n        .disabled {\n            background: #c1c1c1;\n            color: #e1e1e1;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
